import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import styled from 'styled-components';

interface Item {
  label: string;
  value?: any;
}

type Props = {
  data: Item[];
  renderCard: (item: Item, index: number) => any;
  onSelect?: (item: any) => void;
};

export function ScrollingMenu({ data, renderCard, onSelect }: Props) {
  return (
    <Container>
      <ScrollMenu>
        {data.map((item: any, index: number) => (
          <div key={index} className="menu-item" onClick={onSelect}>
            {renderCard(item, index)}
          </div>
        ))}
      </ScrollMenu>
    </Container>
  );
}

const Container = styled.div<any>`
  div {
    /* border: none !important; */
    outline: none !important;
  }
  .menu-item {
    user-select: none;
    cursor: pointer;
    border: none;
    outline: none;
  }

  .scroll-menu-arrow {
    /* padding: 20px; */
    cursor: pointer;
  }
`;
